export const supportedLngs = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português',
  da: 'Dansk',
  ru: 'Русский',
  nl: 'Nederlands',
  sv: 'Svenska',
  pl: 'Polski',
  ar: 'العربية',
  zh: '中文',
  ur: 'اردو',
  hi: 'हिंदी',
};


const i18nConfig = {
    locales:  Object.keys(supportedLngs),
    defaultLocale: 'en',
    prefixDefault: false,
  };
  
export default i18nConfig;